import { render } from "./policies-index.vue?vue&type=template&id=f7ef35d0"
import script from "./policies-index.vue?vue&type=script&lang=js"
export * from "./policies-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__